"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingTimer = void 0;
var mobx_1 = require("mobx");
var DEFAULT_TIMEOUT = 3000;
var LoadingTimer = /** @class */ (function () {
    function LoadingTimer(timeoutMs) {
        if (timeoutMs === void 0) { timeoutMs = DEFAULT_TIMEOUT; }
        Object.defineProperty(this, "timeoutMs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: timeoutMs
        });
        Object.defineProperty(this, "isLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "stillLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "loadingTimer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        mobx_1.makeObservable(this, {
            isLoading: mobx_1.observable,
            stillLoading: mobx_1.observable,
            startLoading: mobx_1.action,
            finishLoading: mobx_1.action,
            stillLoadingCallback: mobx_1.action,
        });
    }
    /**
     * Start a timer
     */
    Object.defineProperty(LoadingTimer.prototype, "startLoading", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            this.isLoading = true;
            this.loadingTimer = setTimeout(function () { return _this.stillLoadingCallback(); }, this.timeoutMs);
        }
    });
    /**
     * Finishes loading and clears the timer
     */
    Object.defineProperty(LoadingTimer.prototype, "finishLoading", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearTimeout(this.loadingTimer);
            this.stillLoading = false;
            this.isLoading = false;
        }
    });
    Object.defineProperty(LoadingTimer.prototype, "stillLoadingCallback", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.stillLoading = true;
        }
    });
    return LoadingTimer;
}());
exports.LoadingTimer = LoadingTimer;
//# sourceMappingURL=LoadingTimer.js.map